export const SET_APPT_OPTIONS = 'SET_APPT_OPTIONS';
export const CLEAR_APPT_OPTIONS = 'CLEAR_APPT_OPTIONS';
export const SET_ADVISOR = 'SET_ADVISOR';



// WEBPACK FOOTER //
// ./src/store/reducers/apptOptions/actionTypes.js